import { Button, Modal } from '@dev-spendesk/grapes';
import React from 'react';

import { useTranslation } from 'src/core/common/hooks/useTranslation';

type DisableInstantPaymentModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export const DisableInstantPaymentModal = ({
  isOpen,
  onClose,
  onConfirm,
}: DisableInstantPaymentModalProps) => {
  const { t } = useTranslation('global');

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={t(
        'generalSettings.instantPaymentLimits.amountLimitSection.disableAmountLimitModal.title',
      )}
      subtitle={t(
        'generalSettings.instantPaymentLimits.amountLimitSection.disableAmountLimitModal.description',
      )}
      actions={[
        <Button
          variant="secondaryNeutral"
          key="cancel"
          text={t('misc.cancel')}
          onClick={onClose}
        />,
        <Button
          variant="primaryAlert"
          key="confirm"
          text={t(
            'generalSettings.instantPaymentLimits.amountLimitSection.disableAmountLimitModal.confirmButton',
          )}
          onClick={onConfirm}
        />,
      ]}
      iconName="triangle-warning"
      iconVariant="alert"
    />
  );
};
